function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3307 16H1.66933C0.749333 16 0 15.2513 0 14.3307V3.00333C0 2.08267 0.749333 1.33333 1.67 1.33333H14.33C15.2507 1.33333 16 2.08267 16 3.00333V14.3307C16 15.2513 15.2513 16 14.3307 16V16ZM1.67 2.66667C1.48467 2.66667 1.33333 2.818 1.33333 3.00333V14.3307C1.33333 14.516 1.484 14.6667 1.66933 14.6667H14.3307C14.516 14.6667 14.6667 14.516 14.6667 14.3307V3.00333C14.6667 2.818 14.5153 2.66667 14.33 2.66667H1.67V2.66667ZM15.3333 5.33333H0.666667C0.298667 5.33333 0 5.03467 0 4.66667C0 4.29867 0.298667 4 0.666667 4H15.3333C15.702 4 16 4.29867 16 4.66667C16 5.03467 15.702 5.33333 15.3333 5.33333ZM3.33333 3.33333C2.96533 3.33333 2.66667 3.03467 2.66667 2.66667V0.666667C2.66667 0.298667 2.96533 0 3.33333 0C3.70133 0 4 0.298667 4 0.666667V2.66667C4 3.03467 3.70133 3.33333 3.33333 3.33333ZM12.6667 3.33333C12.298 3.33333 12 3.03467 12 2.66667V0.666667C12 0.298667 12.298 0 12.6667 0C13.0353 0 13.3333 0.298667 13.3333 0.666667V2.66667C13.3333 3.03467 13.0353 3.33333 12.6667 3.33333Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00016 13.3333C4.36835 13.3333 4.66683 13.0349 4.66683 12.6667C4.66683 12.2985 4.36835 12 4.00016 12C3.63197 12 3.3335 12.2985 3.3335 12.6667C3.3335 13.0349 3.63197 13.3333 4.00016 13.3333Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.00016 10.6673C4.36835 10.6673 4.66683 10.3688 4.66683 10.0007C4.66683 9.63246 4.36835 9.33398 4.00016 9.33398C3.63197 9.33398 3.3335 9.63246 3.3335 10.0007C3.3335 10.3688 3.63197 10.6673 4.00016 10.6673Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00016 13.3333C6.36835 13.3333 6.66683 13.0349 6.66683 12.6667C6.66683 12.2985 6.36835 12 6.00016 12C5.63197 12 5.3335 12.2985 5.3335 12.6667C5.3335 13.0349 5.63197 13.3333 6.00016 13.3333Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00016 10.6673C6.36835 10.6673 6.66683 10.3688 6.66683 10.0007C6.66683 9.63246 6.36835 9.33398 6.00016 9.33398C5.63197 9.33398 5.3335 9.63246 5.3335 10.0007C5.3335 10.3688 5.63197 10.6673 6.00016 10.6673Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00016 7.99935C6.36835 7.99935 6.66683 7.70087 6.66683 7.33268C6.66683 6.96449 6.36835 6.66602 6.00016 6.66602C5.63197 6.66602 5.3335 6.96449 5.3335 7.33268C5.3335 7.70087 5.63197 7.99935 6.00016 7.99935Z",
  fill: "currentColor"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 13.3333C10.3684 13.3333 10.6668 13.0349 10.6668 12.6667C10.6668 12.2985 10.3684 12 10.0002 12C9.63197 12 9.3335 12.2985 9.3335 12.6667C9.3335 13.0349 9.63197 13.3333 10.0002 13.3333Z",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 10.6673C10.3684 10.6673 10.6668 10.3688 10.6668 10.0007C10.6668 9.63246 10.3684 9.33398 10.0002 9.33398C9.63197 9.33398 9.3335 9.63246 9.3335 10.0007C9.3335 10.3688 9.63197 10.6673 10.0002 10.6673Z",
  fill: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0002 7.99935C10.3684 7.99935 10.6668 7.70087 10.6668 7.33268C10.6668 6.96449 10.3684 6.66602 10.0002 6.66602C9.63197 6.66602 9.3335 6.96449 9.3335 7.33268C9.3335 7.70087 9.63197 7.99935 10.0002 7.99935Z",
  fill: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0002 10.6673C12.3684 10.6673 12.6668 10.3688 12.6668 10.0007C12.6668 9.63246 12.3684 9.33398 12.0002 9.33398C11.632 9.33398 11.3335 9.63246 11.3335 10.0007C11.3335 10.3688 11.632 10.6673 12.0002 10.6673Z",
  fill: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0002 7.99935C12.3684 7.99935 12.6668 7.70087 12.6668 7.33268C12.6668 6.96449 12.3684 6.66602 12.0002 6.66602C11.632 6.66602 11.3335 6.96449 11.3335 7.33268C11.3335 7.70087 11.632 7.99935 12.0002 7.99935Z",
  fill: "currentColor"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 13.3333C8.36835 13.3333 8.66683 13.0349 8.66683 12.6667C8.66683 12.2985 8.36835 12 8.00016 12C7.63197 12 7.3335 12.2985 7.3335 12.6667C7.3335 13.0349 7.63197 13.3333 8.00016 13.3333Z",
  fill: "currentColor"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 10.6673C8.36835 10.6673 8.66683 10.3688 8.66683 10.0007C8.66683 9.63246 8.36835 9.33398 8.00016 9.33398C7.63197 9.33398 7.3335 9.63246 7.3335 10.0007C7.3335 10.3688 7.63197 10.6673 8.00016 10.6673Z",
  fill: "currentColor"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00016 7.99935C8.36835 7.99935 8.66683 7.70087 8.66683 7.33268C8.66683 6.96449 8.36835 6.66602 8.00016 6.66602C7.63197 6.66602 7.3335 6.96449 7.3335 7.33268C7.3335 7.70087 7.63197 7.99935 8.00016 7.99935Z",
  fill: "currentColor"
});

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b0fcfcce.svg";
export { ForwardRef as ReactComponent };